const StudyStatusEnum = {
    NO_KOS: 0,
    KOS_CREATED: 1,
    KOS_SENT_SUCCESS: 2,
    KOS_REMOVED: 3,
    KOS_ERROR: 4,
    SENT_ERROR: 5,
    KOS_SENT_PARTIAL_SUCCESS: 6,
}

export default StudyStatusEnum